import { Sparkles, ListPlus, BellRing, Gem, ArrowRight } from "lucide-react";

const steps = [
  {
    icon: ListPlus,
    step: "1",
    title: "Curate with intent",
    description:
      "Add items from any boutique or brand. From high-end fashion to sustainable home goods, your wishlist becomes a polished expression of your aesthetic.",
    iconBg: "bg-[hsl(45,90%,50%)] text-black",
  },
  {
    icon: BellRing,
    step: "2",
    title: "The Spark",
    description:
      "Our AI does more than send a link. It sends a Spark — a beautifully timed, personalised nudge to your partner, family, or friends.",
    iconBg: "bg-destructive text-destructive-foreground",
  },
  {
    icon: Gem,
    step: "3",
    title: "Gifting, perfected",
    description:
      "They get the joy of getting it right, and you get the gift you actually wanted. No guesswork, no duplicates, and no awkward almosts.",
    iconBg: "bg-foreground text-background",
  },
];

const HowItWorks = () => {
  return (
    <section className="hero-gradient px-4 py-20">
      <div className="container max-w-4xl mx-auto">
        <div className="mb-8 flex justify-center">
          <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.24em] text-[hsl(45,90%,50%)]">
            <Sparkles className="h-3.5 w-3.5" />
            The art of the Spark
          </div>
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-center text-foreground mb-4">
          How it works
        </h2>
        <p className="text-center text-muted-foreground mb-12 max-w-2xl mx-auto">
          Three refined steps between wanting something beautiful and receiving it with ease.
        </p>
        <div className="space-y-6">
          {steps.map((s) => (
            <div
              key={s.step}
              className="premium-panel flex items-start gap-5 rounded-[1.75rem] p-6"
            >
              <div className={`flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl shadow-lg ${s.iconBg}`}>
                <s.icon className="h-6 w-6" />
              </div>
              <div className="flex-1">
                <p className="mb-2 text-xs font-semibold uppercase tracking-[0.24em] text-destructive">Step {s.step}</p>
                <h3 className="mb-2 text-xl font-bold text-foreground">
                  {s.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{s.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mx-auto mt-12 max-w-3xl text-center">
          <div className="mx-auto mb-8 h-px w-2/3 bg-destructive" />
          <p className="text-base leading-relaxed text-muted-foreground">
            Our intelligent messaging experience bridges the gap between wanting and receiving with far more care than a pasted link ever could.
          </p>
          <div className="mt-4 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.18em] text-destructive">
            Beautiful timing
            <ArrowRight className="h-4 w-4" />
            Better gifts
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
